module.exports = __webpack_public_path__ + "img/tendinite.3cbf6d69.jpg";